const R = require('ramda')
const Promise = require('bluebird')
const PromiseQueue = require('promise-queue')

const utils = require('sci/utils')

PromiseQueue.configure(Promise)

const queue = new PromiseQueue(2, Infinity)

module.exports = {
    resize (uid, file, params, started = null) {
        return queue.add(() => {
            if (started) {
                try {
                    started(uid, file, params)
                } catch (ex) {
                }
            }

            return new Promise((resolve, reject) => {
                const worker = new window.Worker(utils.webpackEntry('worker'))

                worker.addEventListener('message', (evt) => {
                    const { event, data } = evt.data

                    if (event === 'resize-image:complete') {
                        const images = R.pipe(
                            R.toPairs,
                            R.map(([name, file]) => {
                                return [name, {
                                    file,
                                    url: URL.createObjectURL(file)
                                }]
                            }),
                            R.fromPairs
                        )(data.images)

                        resolve({
                            uid: data.uid,
                            images
                        })

                        worker.terminate()
                    } else if (event === 'resize-image:failed') {
                        reject(new Error('resize failed'))
                        worker.terminate()
                    }
                })

                worker.postMessage({
                    event: 'resize-image',
                    data: {
                        uid,
                        file,
                        params
                    }
                })
            })
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/image-resizer.js